export const VERSION = '1.18.0';
